import { lazy, Suspense, useEffect } from 'react';

import AOS from 'aos';
import { Helmet } from 'react-helmet';
import { useProvider } from 'utils/providers/Provider';

import Loading from './Loading';

const Private = lazy(() => import('./private'));
const Public = lazy(() => import('./public'));

function Routes() {
  const { state } = useProvider();

  if (state.isAuthenticated) return <Private />;

  return <Public />;
}

function Page() {
  useEffect(() => {
    AOS.init({
      disable: false,
      offset: 10,
      duration: 550,
    });
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{import.meta.env.VITE_APP_TITLE}</title>
      </Helmet>
      <Suspense fallback={<Loading />}>
        <Routes />
      </Suspense>
    </>
  );
}

export default Page;
